import * as tslib_1 from "tslib";
import { Component, Watch } from "vue-property-decorator";
import { H3Field } from 'h3-mobile-vue';
import { RelevanceFormControl } from "@cloudpivot/form/src/common/controls/relevance-form-control";
import RelevanceFormModal from "./relevance-form-modal.vue";
import common from '@cloudpivot/common';
import ControlBack from '@cloudpivot/form/src/common/directives/control-back';
// import TransferDom from '../../../directives/transfer-dom';
import { deepCopy, parseUrlParam } from '@cloudpivot/form/utils';
let MobileRelevanceFormMulti = class MobileRelevanceFormMulti extends RelevanceFormControl {
    constructor() {
        super(...arguments);
        this.showModal = false;
    }
    show() {
        this.showModal = true;
    }
    close() {
        this.showModal = false;
        window.history.go(-1);
    }
    onShowModalChange(showModal) {
        console.log('window.history===>', window.history);
        var that = this;
        function toogleShowModalFn(e) {
            if (that.showModal) {
                that.showModal = false;
            }
        }
        function pushHistory() {
            var state = {
                title: "title",
                url: "#"
            };
            window.history.pushState(state, "title", "#");
        }
        if (showModal) {
            pushHistory();
            window.addEventListener("popstate", toogleShowModalFn, false);
        }
        else {
            window.removeEventListener('popstate', toogleShowModalFn, false);
        }
    }
    showError(text) {
        this.$h3.toast.show({
            text,
            autoHide: true,
            iconType: text.length < 8 ? "close" : ""
        });
    }
    get inputPlaceholder() {
        if (this.isScan) {
            return this.$t("cloudpivot.form.renderer.scanInput");
        }
        return this.placeholder;
    }
    clear() {
        this.ctrl.value = [];
    }
    scan() {
        // const url = "http://47.107.160.206/mobile/?corpId=dingcebb92833861bfd735c2f4657eb6378f&agentId=217572455&schemaCode=model_1_1&sheetCode=null&id=6d49f6149b9f4640931ae3a27732c670&mode=form"
        // const url = "http://47.107.160.206/mobile/?workflowInstanceId=435a94545f30415180772d57dd151777&workItemId=254ee20feb564a459a0b340f031ee649&corpId=dingcebb92833861bfd735c2f4657eb6378f&agentId=217572455&mode=form&isWorkFlow=true#/form/detail?workflowInstanceId=435a94545f30415180772d57dd151777&workitemId=254ee20feb564a459a0b340f031ee649";
        // const url = "http://47.107.160.206/mobile/el.html?c=1vgZIyqyIXS";
        //  const url = "http://47.107.160.206/mobile/el.html?w=1vh0cqhjIJO";
        // const url = "http://47.107.160.206/form/detail?sheetCode=ywff&objectId=PO_20.0_00000&schemaCode=ywff&isWorkFlow=false&return=%2Fapplication%2Fsilver%2Fapplication-list%2Fywff%3FparentId%3Dafeb204e719a6d9401719a77445e0002%26code%3Dywff%26openMode%26pcUrl%26queryCode%3D%26iframeAction%3Ddetai"
        //const url = "http://47.107.160.206/mobile/?corpId=dingcebb92833861bfd735c2f4657eb6378f&agentId=217572455&schemaCode=bd233&sheetCode=null&mode=form"
        RelevanceFormControl.service.scan(this.setVal);
        // this.setVal('34234234423423');
    }
    setVal(val) {
        const query = parseUrlParam(val);
        if (!query) {
            this.showError(this.$t("cloudpivot.form.runtime.tip.qrCodeError"));
            return;
        }
        let params = {};
        // 业务表单
        if (query.schemaCode && (query.id || query.objectId)) {
            params.schemaCode = query.schemaCode;
            params.objectId = query.id || query.objectId;
            params.sheetCode = query.sheetCode;
            this.loadForm(params);
            return;
        }
        // 流程表单
        if (query.workflowInstanceId && query.workItemId) {
            params.workflowInstanceId = query.workflowInstanceId;
            params.workitemId = query.workItemId;
            this.loadForm(params);
            return;
        }
        // 外链业务表单
        if (query.c) {
            params.ssc = query.c;
            this.loadForm(params);
            return;
        }
        // 外链流程表单
        if (query.w) {
            this.externalLinkSheet(query.w);
            return;
        }
        // 批量打印二维码
        if (query.sCode) {
            this.shortCodeConfig(query.sCode);
            return;
        }
        if (query.workflowCode && query.corpId && query.agentId) {
            this.showError(this.$t("cloudpivot.form.runtime.tip.qrCodeNoData"));
            return;
        }
        if (query.schemaCode && !query.id && !query.objectId) {
            this.showError(this.$t("cloudpivot.form.runtime.tip.qrCodeNoData"));
            return;
        }
        this.showError(this.$t("cloudpivot.form.runtime.tip.qrCodeError"));
    }
    shortCodeConfig(sCode) {
        RelevanceFormControl.service.shortCodeConfig(sCode).then(res => {
            if (res.errcode === 0) {
                const json = JSON.parse(res.data.pairValue);
                const qrcodeParams = {
                    formCode: json.sheetCode,
                    schemaCode: json.schemaCode,
                    objectId: json.id
                };
                this.loadForm(qrcodeParams);
            }
            else {
                this.showError(res.errmsg);
            }
        });
    }
    // 外链处理
    externalLinkSheet(id) {
        RelevanceFormControl.service.externalLinkSheet(id, 'w').then(res => {
            if (res.errcode === 0) {
                const workflowInstanceId = res.data.workflowInstanceId;
                if (workflowInstanceId) {
                    const params = {
                        workflowInstanceId
                    };
                    this.loadForm(params);
                }
            }
            else {
                this.showError(res.errmsg);
            }
        });
    }
    loadForm(params) {
        RelevanceFormControl.service.loadForm(params).then((res) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (res.errcode === 0) {
                const { schemaCode, data, loadedFromDb } = res.data.bizObject;
                if (schemaCode !== this.controlOpts.schemaCode) {
                    this.showError(this.$t("cloudpivot.form.runtime.tip.qrCodeNoData"));
                    return;
                }
                if (!loadedFromDb) {
                    this.showError(this.$t("cloudpivot.form.runtime.tip.qrCodeNoData"));
                    return;
                }
                const item = yield this.convertForMappings(data);
                this.ctrl.value = item;
                setTimeout(() => {
                    this.ctrl.value = deepCopy(item);
                }, 500);
            }
            else {
                this.showError(res.errmsg);
            }
        }));
    }
    get val() {
        return this.ctrl.value || [];
    }
    get names() {
        if (Array.isArray(this.ctrl.value) && this.ctrl.value.length > 0) {
            return this.ctrl.value.map(item => item[this.getDisplayField]).join(";");
        }
        else {
            if (this.ctrl.value) {
                return this.ctrl.value[this.getDisplayField];
            }
            else {
                return "";
            }
        }
    }
    get ids() {
        if (Array.isArray(this.ctrl.value) && this.ctrl.value.length > 0) {
            return this.ctrl.value.map(item => item.id).join(";");
        }
        else {
            if (this.ctrl.value) {
                return this.ctrl.value.id;
            }
            else {
                return "";
            }
        }
    }
    get isEditState() {
        return !this.readonly || (this.showLink && this.ctrl.value && this.ctrl.value.id);
    }
    onClick(id) {
        if (this.readonly) {
            if (this.showLink) {
                super.open(id);
            }
        }
        else {
            this.show();
        }
    }
    created() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            //展示字段需取数据项列表中的relativePropertyCode;
            // let ls = await this.getRelativeDataList();
            // let dataModal: any = ls.find((c: any) => c.code === this.control.key);
            let dataModal = this.getDataItem(this.control.key, this.control.parentKey);
            if (!dataModal) {
                // 兼容列表查询条件没有传入DataItem。且查询条件只是存在主表；
                let ls = yield this.getRelativeDataList(true);
                dataModal = ls.find((c) => c.code === this.control.key);
            }
            //覆盖数据项options中的displayField（表单设计中的displayField，若在数据模型中重新定义一次后，会导致与后台的展示字段对应不上，所以直接拿后台的展示字段即可）
            this.control.options.displayField = dataModal && dataModal.relativePropertyCode
                ? dataModal.relativePropertyCode
                : "name";
        });
    }
    onChange(val) {
        if (Array.isArray(val) && val.length > 0) {
            this.ctrl.value = val;
            setTimeout(() => {
                this.ctrl.value = deepCopy(val);
            }, 500);
        }
        else {
            this.ctrl.value = [];
        }
        this.close();
    }
};
tslib_1.__decorate([
    Watch('showModal')
], MobileRelevanceFormMulti.prototype, "onShowModalChange", null);
MobileRelevanceFormMulti = tslib_1.__decorate([
    Component({
        name: "relevance-form",
        components: {
            RelevanceFormModal,
            H3Field
        },
        directives: {
            ControlBack,
            TransferDom: common.directives.transferDom
        }
    })
], MobileRelevanceFormMulti);
export default MobileRelevanceFormMulti;
